import { defineMessages } from 'react-intl';

const messages = defineMessages({
  denyTitle: {
    id: 'App.AffordableWaitlistActions.DenyTitle',
    defaultMessage: 'Deny Applicant',
  },
  permissionRequired: {
    id: 'App.AffordableWaitlistActions.PermissionRequired',
    defaultMessage: 'Permission required',
  },
  cancelTitle: {
    id: 'App.AffordableWaitlistActions.CancelTitle',
    defaultMessage: 'Cancel Waitlist Application',
  },
  cancelBanner: {
    id: 'App.AffordableWaitlistActions.CancelBanner',
    defaultMessage: 'The Applicant will be removed from all waitlists.',
  },
  cancelDescriptionTitle: {
    id: 'App.AffordableWaitlistActions.CancelDescriptionTitle',
    defaultMessage:
      'Removes the applicant from the waiting list and ends the application',
  },
  cancelDescriptionHelperText: {
    id: 'App.AffordableWaitlistActions.CancelDescriptionHelperText',
    defaultMessage:
      'Use when the applicant cannot be reached, has withdrawn, or found other housing.',
  },
  continueApplicationLabel: {
    id: 'App.AffordableWaitlistActions.ContinueApplicationLabel',
    defaultMessage:
      'Continue application for {programs} only units at this property?',
  },
  yes: {
    id: 'App.AffordableWaitlistActions.Yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'App.AffordableWaitlistActions.No',
    defaultMessage: 'No',
  },
  reason: {
    id: 'App.AffordableWaitlistActions.Reason',
    defaultMessage: 'Reason',
  },
  notes: {
    id: 'App.AffordableWaitlistActions.Notes',
    defaultMessage: 'Notes',
  },
  notesRequired: {
    id: 'App.AffordableWaitlistActions.NotesRequired',
    defaultMessage: 'Notes are required when (Other - See Notes) is selected',
  },
  limitReached255: {
    id: 'App.AffordableWaitlistActions.LimitReached255',
    defaultMessage:
      'Your note exceeds the 255 character limit. Please shorten your text.',
  },
  cancelSuccess: {
    id: 'App.AffordableWaitlistActions.CancelSuccess',
    defaultMessage: 'Applicant canceled successfully',
  },
  addSuccess: {
    id: 'App.AffordableWaitlistActions.AddSuccess',
    defaultMessage: 'Applicant added to waitlist successfully',
  },
  addMovedToInProcessSuccess: {
    id: 'App.AffordableWaitlistActions.AddMovedToInProcessSuccess',
    defaultMessage: 'Applicant moved to In Process',
  },
  confirm: {
    id: 'App.AffordableWaitlistActions.Confirm',
    defaultMessage: 'Confirm',
  },
  dismiss: {
    id: 'App.AffordableWaitlistActions.Dismiss',
    defaultMessage: 'Cancel',
  },
});

export default messages;
